import React, { useEffect, useState } from 'react';
import './ConfigTablas.scss';
import { DataGrid, ScrollView, SelectBox } from 'devextreme-react';
import { Column, Editing, Export, LoadPanel, Pager, Paging, Search, SearchPanel } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../api/api.configuration';
import { newToast, ToolbarSimple } from '../../components';

export default () => {
  const { getConfigurableTables, getFieldsByTable, getDataByTable, createItemTable, updateItemTable, deleteItemTable } = useApiConfiguration();

  const [tables, setTables] = useState<string[]>([]);
  const [selectedTable, setSelectedTable] = useState<string | null>(null);
  const [columns, setColumns] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const gridRef = React.useRef<DataGrid>(null);

  useEffect(() => {
    const fetchTables = async () => {
      const result = await getConfigurableTables();
      // Transformar las tablas para incluir display y value
      const transformedTables = result.map((t: any) => ({
        display: t.TABLE_NAME.replace(/^SysA_|^SysI_|^Cmb_/, ''), // Nombre sin prefijo
        value: t.TABLE_NAME, // Nombre completo con prefijo
      }));

      setTables(transformedTables);
    };
    fetchTables();
  }, []);

  useEffect(() => {
    if (!selectedTable) return;
    handleRefresh();
    getFieldsByTable(selectedTable).then((res) => {
      setColumns(res);
    });
  }, [selectedTable]);

  const handleRefresh = () => {
    if (!selectedTable) return;
    getDataByTable(selectedTable).then((res) => {
      setData(res);
    });
  };

  const onRowInserted = async (e: any) => {
    const prefTable = Object.keys(e.data)[0]?.split('_')[0];
    const newData = { ...e.data };
    delete newData[`${prefTable}_Id`];

    //Guardamos el nuevo objeto
    if (selectedTable) {
      gridRef.current?.instance.beginCustomLoading('');
      createItemTable(selectedTable, newData)
        .then((res) => {
          if (res) {
            setData(res);
          }
        })
        .finally(() => {
          gridRef.current?.instance.endCustomLoading();
        });
      return;
    }
    newToast('ERROR', 'No se ha podido guardar el registro', 5);
  };

  const onRowUpdated = async (e: any) => {
    const prefTable = Object.keys(e.data)[0]?.split('_')[0];
    const newData = { ...e.data };
    delete newData[`${prefTable}_Id`];

    //Guardamos el nuevo objeto
    if (selectedTable) {
      gridRef.current?.instance.beginCustomLoading('');
      updateItemTable(selectedTable, `${prefTable}_Id=${e.key}`, newData).finally(() => {
        gridRef.current?.instance.endCustomLoading();
        handleRefresh();
      });
      return;
    }
    newToast('ERROR', 'No se ha podido guardar el registro', 5);
  };

  const onRowRemoved = async (e: any) => {
    const prefTable = Object.keys(e.data)[0]?.split('_')[0];
    const newData = { ...e.data };
    delete newData[`${prefTable}_Id`];

    //Guardamos el nuevo objeto
    if (selectedTable) {
      gridRef.current?.instance.beginCustomLoading('');
      deleteItemTable(selectedTable, `${prefTable}_Id=${e.key}`).finally(() => {
        gridRef.current?.instance.endCustomLoading();
        handleRefresh();
      });
      return;
    }
    newToast('ERROR', 'No se ha podido guardar el registro', 5);
  };

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <ScrollView className='view-wrapper-scroll'>
          <ToolbarSimple title='Mantenimientos'>
            <SelectBox items={tables} value={selectedTable} searchEnabled displayExpr='display' valueExpr='value' onValueChanged={(e) => setSelectedTable(e.value)} placeholder='Selecciona una tabla' width={300} />
            {selectedTable && (
              <DataGrid allowColumnResizing={true} dataSource={data} keyExpr={columns[0]?.COLUMN_NAME} ref={gridRef} showBorders={true} onRowInserted={onRowInserted} onRowUpdated={onRowUpdated} onRowRemoved={onRowRemoved}>
                <LoadPanel enabled={true} />
                <Export enabled={true} />
                <SearchPanel visible />
                <Editing mode='row' allowUpdating allowAdding allowDeleting />
                <Paging defaultPageSize={20} />
                <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
                {columns.map((col) => {
                  const prefix = col.COLUMN_NAME.split('_')[0];
                  if (col.COLUMN_NAME === `${prefix}_Id`) return null;
                  return <Column key={col.COLUMN_NAME} dataField={col.COLUMN_NAME} caption={col.COLUMN_NAME.split('_')[1]} />;
                })}
              </DataGrid>
            )}
          </ToolbarSimple>
        </ScrollView>
      </div>
    </div>
  );
};
